var React = require('react');

function Reset (props) {
    return React.createElement("svg",props,[React.createElement("path",{"stroke":"#737680","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"1.5","d":"M1 7.766c0-3.613 3.15-6.57 7-6.57 2.73 0 5.11 1.446 6.23 3.614M15 8.733c0 3.613-3.15 6.57-7 6.57-2.73 0-5.11-1.446-6.23-3.614","key":0}),React.createElement("path",{"stroke":"#737680","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"1.5","d":"M14.86 1l-.56 3.876-4.2-.526M1.14 15.5l.56-3.876 4.2.526","key":1})]);
}

Reset.defaultProps = {"width":"16","height":"17","fill":"none","viewBox":"0 0 16 17"};

module.exports = Reset;

Reset.default = Reset;
